import React from 'react';

import SiretTrackedImport from '../../components/Admin/SiretTrackedImport';

function SiretTrackedImportView() {
  return (
    <SiretTrackedImport />
  );
}

export default SiretTrackedImportView;
